
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import Head from 'next/head';
import Link from 'next/link';
import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';

import { GoatCleanCard } from 'goat-clean/components/GoatCleanCard';
import { GOAT_CLEAN_SECTIONS } from 'goat-clean/enums/goatCleanEnums';
import { usePageMetadata } from 'shared/hooks/usePageMetadata';
import { t } from 'localization/utils/t';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';
import { getTranslations } from 'shared/utils/getTranslations';

const TP = 'pages.goatClean.process';

const GoatCleanProcessPage = () => {
  const goatCleanSections = getTranslations(GOAT_CLEAN_SECTIONS);
  const { pageTitle } = usePageMetadata({
    defaultTitle: t(`${TP}.pageTitle`, 'GOAT Clean Process '),
  });

  return (
    <GoatCleanProcessPage.Container>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="og:title" />
      </Head>
      <GoatCleanProcessPage.Title data-qa="goat_clean_process_title">
        {t(`${TP}.title`, 'GOAT Clean Process')}
      </GoatCleanProcessPage.Title>
      <GoatCleanProcessPage.Steps>
        {goatCleanSections.map((section, index) => (
          <GoatCleanCard key={section?.title} {...section} stepNumber={Number(index) + 1} />
        ))}
      </GoatCleanProcessPage.Steps>
      <Link href="/goat-clean" passHref>
        <GoatCleanProcessPage.ShopGoatCleanLink>
          {t(`${TP}.shop`, 'Shop GOAT Clean')}
        </GoatCleanProcessPage.ShopGoatCleanLink>
      </Link>

      <GoatCleanProcessPage.EmailGoat>
        {t(`${TP}.interest`, `Interested in selling through the GOAT Clean program? Email `)}
        <a
          target="_blank"
          data-qa="goat_clean_email"
          rel="noopener noreferrer"
          href="mailto:clean@goat.com"
        >
          clean@goat.com
        </a>
        .
      </GoatCleanProcessPage.EmailGoat>
    </GoatCleanProcessPage.Container>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await setServerSideTranslations({ locale })),
    },
  };
};

GoatCleanProcessPage.Container = styled.div`
  padding: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    padding: 32px;
  }
`;

GoatCleanProcessPage.Title = styled.div`
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  margin-bottom: 32px;
  text-transform: uppercase;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;

GoatCleanProcessPage.Steps = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
`;

GoatCleanProcessPage.ShopGoatCleanLink = styled.a`
  font-weight: 400;
  text-decoration: underline;
  width: 100%;
  text-align: left;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};

  &:hover {
    text-decoration: underline;
  }
`;

GoatCleanProcessPage.EmailGoat = styled.div`
  font-weight: 400;
  margin-top: 16px;
  max-width: 418px;
  text-align: left;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};

  a {
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default GoatCleanProcessPage;
